/*
 * Black Sale BOEMI — progresso do desconto progressivo no minicart.
 *
 * Todo o estado (contagem, nível, mensagem) é calculado pelo Liquid em
 * snippets/cart-discount-progress.liquid, que o tema re-renderiza a cada
 * alteração do carrinho (cart?view=ajax_side_cart). Este script só anima a
 * barra a partir do último valor conhecido para o novo, sem listeners de
 * carrinho e sem requisições adicionais.
 */
(() => {
  if (customElements.get('cart-discount-progress')) return;

  let lastProgress = 0;

  class CartDiscountProgress extends HTMLElement {
    connectedCallback() {
      const fill = this.querySelector('[data-progress-fill]');
      if (!fill) return;

      const target = Math.min(100, Math.max(0, parseFloat(this.dataset.progress) || 0));
      const from = lastProgress;
      lastProgress = target;

      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (from === target || reduceMotion) {
        fill.style.width = `${target}%`;
        return;
      }

      fill.style.width = `${from}%`;
      fill.getBoundingClientRect();
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          fill.style.width = `${target}%`;
        });
      });
    }
  }

  customElements.define('cart-discount-progress', CartDiscountProgress);
})();
